import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { FAQS } from '../constants'

import { Faq } from '../types'
import { Meta } from '@/features/filters/types'

type FaqsResponse = {
  data: Faq[]
  meta: Meta
}

const getFaqs = async (params: Meta): Promise<FaqsResponse> => {
  const response = await fetchAPI({
    path: `/faqs`,
    params,
  })

  const data = get(response, 'data.faqs', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useFaqs = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: FaqsResponse
}) => {
  return useQuery<FaqsResponse, AxiosError>({
    queryKey: [FAQS, params],
    queryFn: () => getFaqs(params),
    keepPreviousData: true,
    initialData,
  })
}
